export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4697.ea691d13.jpg";